import Vue from "vue"
import Vuex from "vuex"
import * as ua from "../bargain/utils/ua"
import Wechat from "../bargain/utils/wechat"
import * as types from "../bargain/store/mutation-types"
import cookies from "../bargain/utils/cookies"
import * as config from "./config"
import * as url from "../bargain/utils/url"
import * as bargainApi from "../bargain/api/bargain"
import * as userApi from "../bargain/api/user"
import * as uuid from "../bargain/utils/uuid"
import * as request from "../bargain/utils/request"
import localStorage from "../bargain/utils/localStorage"
import * as report from "../bargain/utils/report"
import Raven from "raven-js"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sandbox: url.getParam("sandbox"),
    pf: url.getParam("pf"),
    aid: url.getParam("aid"),
    offerId: url.getParam("offerId"),
    avatar: require("../../../ui/20180706kanjia_p/ossweb-img/u.jpg"),
    openid: "",
    openkey: "",
    sessionId: "",
    sessionType: "",
    wxAppid2: "wx951bdcac522929b6",
    successBargainNum: 0,
    userAgent: ua.getUserAgent(),
    selectedZone: "",
    bargainInfo: "",
    billNo: "",
    isInMSDK: ua.getUserAgent().msdk,
    isOpenerFirstBargainDialogShown: false,
    firstBargainPrice: 0,
    firstBargainCountdown: 0,
    firstBargainId: "",
    firstBargainItem: ""
  },
  getters: {
    sandbox: state => state.sandbox,
    pf: state => state.pf,
    loginState: state => {
      return {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        wxAppid2: state.wxAppid2
      }
    },
    successBargainNum: state => state.successBargainNum,
    selectedZone: state => {
      if (state.isInMSDK) {
        return {
          c: url.getParam("area"),
          v: url.getParam("partition")
        }
      } else {
        return state.selectedZone
      }
    },
    bargainInfo: state => state.bargainInfo,
    offerId: () => {
      return "1450019044"
    },
    firstBargainInfo: state => {
      return {
        price: state.firstBargainPrice,
        countdown: state.firstBargainCountdown,
        bargainId: state.firstBargainId,
        item: state.firstBargainItem
      }
    },
    isOpenerFirstBargainDialogShown: state => state.isOpenerFirstBargainDialogShown
  },
  actions: {
    jumpToMqq({ state }, jumpUrl) {
      if (!jumpUrl) {
        //默认跳活动首页
        jumpUrl = location.href
      }
      if (state.userAgent.weixin) {
        let wechat = new Wechat()
        wechat.api(
          "getInstallState",
          {
            packageUrl: "mqq://",
            packageName: "com.tencent.mobileqq"
          },
          res => {
            if (/get_install_state:yes/.test(res.err_msg)) {
              userApi.jumpToMqq(jumpUrl, state)
            } else {
              alert("请先下载手机QQ！")
            }
          }
        )
      } else {
        userApi.jumpToMqq(jumpUrl, state)
      }
    },
    jumpToWechat({ state }, url) {
      let iframeDom = document.createElement("iframe")
      iframeDom.style.display = "none"

      iframeDom.src = url
      iframeDom.onload = iframeDom.onerror = () => {
        document.body.removeChild(iframeDom)
        iframeDom.onload = iframeDom.onerror = null
      }
      document.body.appendChild(iframeDom)
      location.href = url
      state.offerId
    },
    getLoginState({ state, commit, dispatch }) {
      return new Promise((resolve, reject) => {
        if (!state.openid || !state.openkey) {
          let userAgent = ua.getUserAgent()
          if (userAgent.weixin) {
            let wechat = new Wechat({
              getDetail: 1
            })
            if (wechat.init()) {
              wechat.getOpenid({
                onSuccess: function() {
                  commit(types.SET_USER_LOGIN_STATE, {
                    openid: this.openid,
                    openkey: this.accessToken,
                    sessionId: "hy_gameid",
                    sessionType: "wc_actoken"
                  })
                  if (this.info.headimgurl) {
                    commit(types.SET_USER_AVATAR, this.info.headimgurl)
                  }
                  resolve({
                    openid: this.openid,
                    openkey: this.accessToken,
                    userInfo: this.info
                  })
                },
                onError: () => {
                  reject()
                }
              })
            } else {
              reject()
            }
          } else if (userAgent.QQ) {
            let loginState = {
              openid: cookies.get("uin").substr(1) * 1,
              openkey: cookies.get("skey"),
              sessionId: "uin",
              sessionType: "skey"
            }
            commit(types.SET_USER_LOGIN_STATE, loginState)
            commit(types.SET_USER_AVATAR, `//q.qlogo.cn/g?b=qq&nk=${loginState.openid}&s=100`)
            // dispatch("getQQNickname", loginState.openid)
            // commit(types.SET_USER_AVATAR, `${location.protocol}//my.pay.qq.com/cgi-bin/account/get_qq_face.cgi?uin=${loginState.openid}`)
            resolve(loginState)
          } else if (window._msdkLoginParams && state.isInMSDK) {
            if (_msdkLoginParams.acctype === "wx" || _msdkLoginParams.acctype === "weixin") {
              let loginState = {
                openid: _msdkLoginParams.openid,
                openkey: _msdkLoginParams.access_token,
                sessionId: "hy_gameid",
                sessionType: "wc_actoken",
                wxAppid2: _msdkLoginParams.appid,
                accountType: "wx"
              }
              commit(types.SET_USER_LOGIN_STATE, loginState)
              resolve(loginState)
            } else if (_msdkLoginParams.acctype === "qq") {
              /**
               *  {
    "acctype": "qq",
    "appid": "1104922185",
    "openid": "4C5782CCFEF74AE493A71B526C43DDC1",
    "access_token": "E51744B676BDABA33EF0E9160609E279",
    "pay_token": "45DD6BF183D747520BCF974977835EFF",
    "platid": "0"
   }
               */
              let loginState = {
                openid: _msdkLoginParams.openid,
                openkey: _msdkLoginParams.access_token,
                sessionId: "openid",
                sessionType: "kp_accesstoken",
                accountType: "qq"
              }
              commit(types.SET_USER_LOGIN_STATE, loginState)
              resolve(loginState)
            } else {
              reject("无登陆态")
            }
          } else {
            dispatch("reportUserAction", {
              iformat: config.REPORT.PAGEVIEW.OUTGAME_BARGAIN_NON_WECHAT_AND_QQ
            })
            reject("无登陆态")
          }
        } else {
          resolve({
            openid: state.openid,
            openkey: state.openkey,
            sessionId: state.sessionId,
            sessionType: state.sessionType,
            wxAppid2: state.wxAppid2
          })
        }
      })
        .then(loginState => {
          document.querySelector("#page_loading").style.display = "none"
          return loginState
        })
        .catch(res => {
          // if (res == "无登陆态") {
          //   document.querySelector("#page_unlogin").style.display = "block"
          // }
          Raven.captureException(new Error("get-login-state-error"), {
            tags: { type: "get-login-state-error" },
            extra: {
              res,
              state
            }
          })
          document.querySelector("#page_loading").style.display = "none"
          // document.querySelector("#app").style.display = "none"
          console.log(res)
          throw res
        })
    },
    msdkShareTo({ dispatch, state }, { selected, bargainId, pf, offerId, item }) {
      let shareParams = {
        // title: config.SHARE_DETAIL.OPEN_TITLE,
        desc: config.SHARE_DETAIL.OPEN_DESC,
        title: `帮砍一刀！我想1折买${item.product_name}`,
        url: `${location.protocol}//${location.host}${location.pathname}?pf=${pf}${
          state.sandbox ? "&sandbox=" + state.sandbox : ""
        }#/open/${bargainId}/${offerId}?a=1`,
        imgData: config.SHARE_DETAIL.INGAME_BASE64_ICON
      }

      if (selected === "weixin" || selected === "pengy") {
        shareParams.MsdkMethod = "WGSendToWeiXinWithUrl"
        shareParams.scene = selected === "weixin" ? "0" : "1"
        shareParams.mediaTagName = "MSG_INVITE"
        if (selected == "pengy") {
          dispatch("reportUserAction", {
            iformat: config.REPORT.CLICK.INGAME_SHARE_TIMELINE,
            resultInfo: `bargain_id=${bargainId}`
          })
        }
        if (selected == "weixin") {
          dispatch("reportUserAction", {
            iformat: config.REPORT.CLICK.INGAME_SHARE_WECHAT,
            resultInfo: `bargain_id=${bargainId}`
          })
        }
      } else {
        if (selected == "qzone") {
          shareParams.scene = 1
          dispatch("reportUserAction", {
            iformat: config.REPORT.CLICK.INGAME_SHARE_QZONE,
            resultInfo: `bargain_id=${bargainId}`
          })
        }
        if (selected == "qq") {
          shareParams.scene = 2
          dispatch("reportUserAction", {
            iformat: config.REPORT.CLICK.INGAME_SHARE_QQ,
            resultInfo: `bargain_id=${bargainId}`
          })
        }
        shareParams.MsdkMethod = "WGSendToQQ"
      }
      setTimeout(() => {
        if (window.msdkShare) {
          window.msdkShare(JSON.stringify(shareParams))
        }
      }, 100)
    },
    reportUserAction({ state, getters }, params) {
      let data = {
        3: state.openid,
        8: params.resultInfo || "",
        // 19: getters.currentItem && getters.currentItem.code,
        13: 1,
        21: params.iformat,
        26: `vip_m-${state.pf || "pay_html5"}_-html5`,
        24: url.getParam("offerId") || getters.offerId,
        37: state.sessionId,
        43: state.sessionType,
        41: "wx951bdcac522929b6",
        50: navigator.userAgent,
        // 51: getters.aid,
        36: location.href
      }

      setTimeout(() => {
        report.dataReport(data)
      }, 0)
    },
    showMqqShareMenu({ state }) {
      userApi.showShareMenu(state)
    },
    setOnShareHandler({ dispatch, state }, { page, item, bargainId }) {
      let params = {
        title: config.SHARE_DETAIL.TITLE,
        desc: config.SHARE_DETAIL.DESC,
        // // link: location.href,
        // link: `${location.origin}${location.pathname}${location.search}${location.hash}`,
        wxAppid2: state.wxAppid2,
        img: config.SHARE_DETAIL.ICON
      }
      if (page == "index") {
        params.title = config.SHARE_DETAIL.INDEX_TITLE
        params.desc = config.SHARE_DETAIL.INDEX_DESC
      } else if (page == "open") {
        params.title = `帮砍一刀！我想1折买${item.product_name}`
        params.desc = config.SHARE_DETAIL.OPEN_DESC
      }

      let userAgent = ua.getUserAgent()
      if (userAgent.QQ) {
        params.pf = "__mds_qqbargain.share"
        params.reportCallback = res => {
          if (res.retCode == 0) {
            dispatch("reportUserAction", {
              iformat: config.REPORT.CLICK.SHARE_BARGAIN_IN_QQ_SUCCESS
            })
          } else if (res.retCode == 1) {
            dispatch("reportUserAction", {
              iformat: config.REPORT.CLICK.SHARE_BARGAIN_IN_QQ_FAILURE
            })
          }
          dispatch("reportUserAction", {
            iformat: config.REPORT.CLICK.SHARE_BARGAIN_IN_QQ,
            resultInfo: `bargain_id=${bargainId}`
          })
        }
        userApi.setOnMqqShareHandler(params)
      } else if (userAgent.weixin) {
        params.pf = "__mds_wxbargain.share"
        params.reportCallback = () => {
          dispatch("reportUserAction", {
            iformat: config.REPORT.CLICK.SHARE_BARGAIN_IN_WECHAT,
            resultInfo: `bargain_id=${bargainId}`
          })
        }
        userApi.setOnWechatShareHandler(params)
      }
    },
    getUserRecommendZone({ state, getters }) {
      return userApi.getUserRecommend({
        sandbox: state.sandbox,
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        offerId: getters.offerId,
        model: state.userAgent.iOS ? "wzry_partition_ios_recomm" : "wzry_partition_android_recomm"
      })
    },
    getBargainHelperRecommend({ state, getters }) {
      return userApi.getUserRecommend({
        sandbox: state.sandbox,
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        offerId: getters.offerId,
        model: config.GUESS_YOU_LIKE
      })
    },
    getZoneInfo({ state }) {
      return new Promise((resolve, reject) => {
        if (window["YXZJServerSelect"]) {
          resolve(window["YXZJServerSelect"].STD_DATA)
        } else {
          request
            .getScript(`//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/yxzj_server_select_utf8.js?t=${new Date().getTime()}`)
            .then(() => {
              resolve(window["YXZJServerSelect"].STD_DATA)
              state.offerId
            })
            .catch(error => {
              reject(error)
            })
        }
      })
    },
    getRoleInfo({ state, getters }, { platformId, area, zoneid }) {
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        wxAppid2: state.wxAppid2,
        offerId: getters.offerId,
        sandbox: state.sandbox,
        clientVersion: state.userAgent.iOS ? "iap" : "android",
        platformId,
        area,
        zoneid
      }
      return userApi.getRoleInfo(params)
    },
    setSelectedZone({ commit, state, getters }, zone) {
      commit(types.SET_SELECTED_ZONE, zone)
      localStorage.set(`wzry_bargain_${getters.offerId}_${state.openid}`, JSON.stringify(zone)) //把用户选过的大区存起来
    },
    getAllBargainList({ state, commit, getters }, extend) {
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        offerId: getters.offerId,
        sandbox: state.sandbox,
        wxAppid2: state.wxAppid2,
        bargainGroup: config.ACTIVITY[getters.offerId]
      }
      return bargainApi
        .getActivities(
          params,
          Object.assign(
            {
              recomm_model: config.RECOMMEND_MODEL
            },
            extend
          )
        )
        .then(info => {
          if (info && info.buybargain && info.buybargain.bargain) {
            commit(types.SET_BARGAIN_LIST, info.buybargain.bargain.rule_item)
            commit(types.SET_SUCCESS_BARGAIN_NUM, info.buybargain.bargain.bargain_success_num)
            return info.buybargain.bargain.rule_item
          }
        })
    },
    getMyBargains({ state, getters }) {
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        offerId: getters.offerId,
        sandbox: state.sandbox,
        wxAppid2: state.wxAppid2,
        bargainGroup: config.ACTIVITY[getters.offerId]
      }
      return bargainApi.getMyBargains(params)
    },
    getBargainById({ state, commit }, { bargainId, currentPage, pageSize, offerId }) {
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        offerId: offerId,
        sandbox: state.sandbox,
        wxAppid2: state.wxAppid2,
        bargainGroup: config.ACTIVITY[offerId],
        bargainId,
        currentPage,
        pageSize
      }
      return bargainApi.getBargains(params).then(info => {
        let bargainInfo = info.bargain_info
        bargainInfo.user_comm_id = info.user_comm_id
        if (currentPage == 1) {
          //第一页在设置砍价信息,后面的分页都是为了获取参砍人
          commit(types.SET_BARGAIN_INFO, bargainInfo)
          if (bargainInfo.bill_no) {
            commit(types.GENERATE_BILL_UUID, bargainInfo.bill_no)
          } else {
            commit(types.GENERATE_BILL_UUID, uuid.generate())
          }
        }
        return bargainInfo
      })
    },
    openBargain({ state, getters }, { productId, extendParams }) {
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        offerId: getters.offerId,
        sandbox: state.sandbox,
        wxAppid2: state.wxAppid2,
        bargainGroup: config.ACTIVITY[getters.offerId],
        productId
      }
      return bargainApi.openBargain(params, extendParams)
    },
    sendQualification({ getters, state }, { group_id, gameid }) {
      let offerId = config.SEND_QUALIFICATION_OFFERID
      return bargainApi.sendQualication({
        openid: getters.loginState.openid,
        openkey: getters.loginState.openkey,
        session_id: getters.loginState.sessionId,
        session_type: getters.loginState.sessionType,
        wx_appid: getters.loginState.wxAppid2,
        offerId: offerId,
        sandbox: getters.sandbox,
        group_id,
        gameid,
        game_platform_id: state.userAgent.iOS ? 0 : 1,
        accounttype: "qb",
        action: "check_whitelist_and_present"
      })
    },
    queryCriticalStrike({ getters }) {
      return bargainApi.getCritialStrike({
        openid: getters.loginState.openid,
        openkey: getters.loginState.openkey,
        sessionId: getters.loginState.sessionId,
        sessionType: getters.loginState.sessionType,
        wxAppid2: getters.loginState.wxAppid2,
        offerId: getters.offerId,
        sandbox: getters.sandbox,
        bargainGroup: config.ACTIVITY[getters.offerId]
      })
    },
    setOpenerBargainDialog({ commit }, status) {
      commit(types.SET_OPENER_FIRST_BARGAIN_DIALOG, status)
    },
    setFirstBargainInfo({ commit }, info) {
      commit(types.SET_OPENER_FIRST_BARGAIN, info)
    },
    helpBargain({ state }, { productId, bargainId, offerId }) {
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        offerId: offerId,
        sandbox: state.sandbox,
        wxAppid2: state.wxAppid2,
        bargainGroup: config.ACTIVITY[offerId],
        action: "bargain_wz_baoji",
        bargainId,
        productId
      }
      return bargainApi.helpBargain(params)
    },
    placeOrder({ state, getters }, { extendParams, gameId, productId, productNum, productName }) {
      // let userAgent = ua.getUserAgent(),
      //       //   gameId
      /*
      gameid区分端游和手游拼接模式
      端游为 "大区id_角色id"
      手游为 "area(标识手Q还是微信)_角色id__分区id"
       */

      // gameId = [state.selectedZone.c || (userAgent.weixin ? "1" : "2"), "", "", state.selectedZone.v].join("_")

      let params = {
        pf: `mds_wechat_gmshop-pay_html5_${state.pf}-${state.userAgent.iOS ? "iap" : "android"}`,
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        offerId: getters.offerId,
        sandbox: state.sandbox,
        wxAppid2: state.wxAppid2,
        bargainGroup: config.ACTIVITY[getters.offerId],
        gameId,
        productId: productId || state.bargainInfo.product_id,
        productNum: productNum || state.bargainInfo.product_num,
        productName: productName || state.bargainInfo.product_name
      }

      return bargainApi.pay(params, extendParams)
    },
    midasPay({ state }, { token, offerId, bargainId, billNo, mid, realPrice }) {
      return bargainApi.initMidas().then(Midas => {
        return new Promise(resolve => {
          let data = {
            params: `/v1/${mid}/${offerId}/mobile_goods_info?token_id=${token}&out_trade_no=${billNo || state.billNo}`,
            pf: `mds_wechat_gmshop-pay_html5_${state.pf}-${state.userAgent.iOS ? "iap" : "android"}`,
            sandbox: state.sandbox,
            drm_info: `bargain_group=${config.ACTIVITY[offerId]}&version=3.0&bargain_id=${bargainId}`,
            openid: state.openid,
            openkey: state.openkey,
            sessionid: state.sessionId,
            sessiontype: state.sessionType,
            wxAppid2: state.wxAppid2,
            closeOnSuccess: 1,
            hideUi: 1,
            hidePrice: 1,
            showCoin: 1,
            realPrice,
            dc: "bank,mcard,hfpay,yb,wsjpay,qqcard",
            // directChannel: "wechat",
            onSuccess: resolve
          }

          if (state.userAgent.weixin) {
            data.change_wx_openid = 1
          }
          if (state.userAgent.iOS) {
            //iOS内屏蔽微信渠道
            data.dc = `${data.dc},wechat,qqwallet,qdqb,qbqd`
            data.directChannel = "game_coin"
          }
          console.log(data)
          Midas.buyGoods(data)
        })
      })
    },
    pay({ state }, { token, offerId, bargainId, billNo, mid }) {
      let params = {
        pf: `mds_wechat_gmshop-pay_html5_${state.pf}-html5`,
        offerId,
        out_trade_no: billNo || state.billNo,
        bargainGroup: config.ACTIVITY[offerId],
        bargainId,
        sandbox: state.sandbox,
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        wxAppid2: state.wxAppid2,
        token_id: token,
        pay_method: "game_coin",
        mid
      }
      let extend = {}
      if (state.sessionType == "wc_actoken" && state.userAgent.weixin) {
        extend.change_wx_openid = 1
      }
      return bargainApi.mobileSaveGoods(params, extend)
    }
  },
  mutations: {
    [types.SET_USER_LOGIN_STATE](state, { openid, openkey, sessionId, sessionType, wxAppid2 }) {
      state.openid = openid
      state.openkey = openkey
      state.sessionId = sessionId
      state.sessionType = sessionType
      wxAppid2 && (state.wxAppid2 = wxAppid2)
    },
    [types.SET_USER_AVATAR](state, avatar) {
      state.avatar = avatar
    },
    [types.SET_SELECTED_ZONE](state, zone) {
      state.selectedZone = zone
    },
    [types.SET_BARGAIN_INFO](state, bargainInfo) {
      state.bargainInfo = bargainInfo
    },
    [types.GENERATE_BILL_UUID](state, uuid) {
      state.billNo = uuid
    },
    [types.SET_SUCCESS_BARGAIN_NUM](state, num) {
      state.successBargainNum = num
    },
    [types.SET_BARGAIN_LIST](state, bargainList) {
      state.bargainList = bargainList
    },
    [types.SET_OPENER_FIRST_BARGAIN](state, firstBargainInfo) {
      state.firstBargainPrice = firstBargainInfo.price
      state.firstBargainCountdown = firstBargainInfo.countdown
      state.firstBargainId = firstBargainInfo.bargainId
      state.firstBargainItem = firstBargainInfo.item
    },
    [types.SET_OPENER_FIRST_BARGAIN_DIALOG](state, isOpenerFirstBargainDialogShown) {
      state.isOpenerFirstBargainDialogShown = isOpenerFirstBargainDialogShown
    }
  },
  strict: process.env.NODE_ENV === "debug"
})
